import React, { FC, useMemo, useState } from "react";
import { Preview } from "@evergis/ui";

import { SmallPreviewContainer } from "./styled";
import { ExpandableTitle } from "../ExpandableTitle/ExpandableTitle";
import { SmallPreview } from "../CameraAttribute/components/SmallPreview";
import { isVisibleContainer } from "../../utils/isVisibleContainer";
import { getSlideshowImages } from "../../utils/getSlideshowImages";
import { useWidgetContext } from "../../../Dashboard/hooks/useWidgetContext";
import { useToggle } from "../../../../hooks/useToggle";
import { FeatureCardSlideshowProps } from "./types";

export const FeatureCardSlideshow: FC<FeatureCardSlideshowProps> = ({
  elementConfig,
  type,
  attributes,
  renderElement,
}) => {
  const { expandedContainers, dataSources } = useWidgetContext(type);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isOpenGallery, toggleGallery] = useToggle();

  const { id, options, attributeName } = elementConfig || {};
  const { expandable, expanded, height, relatedDataSource } = options || {};
  const isVisible = isVisibleContainer(id, expandable, expanded, expandedContainers);

  const images = useMemo(() => {
    const dataSource = relatedDataSource ? dataSources?.find(({ name }) => name === relatedDataSource) : null;
    const array = dataSource
      ? dataSource.features.map(feature => feature.attributes[attributeName as string])
      : getSlideshowImages({
          element: elementConfig,
          attribute: attributes.find(({ name }) => name === (attributeName as string)),
        });

    return (
      array?.map(image => ({
        src: image,
        fileName: image,
      })) || []
    );
  }, [attributeName, attributes, dataSources, elementConfig, relatedDataSource]);

  return (
    <>
      <ExpandableTitle elementConfig={elementConfig} type={type} renderElement={renderElement} />
      {isVisible && (
        <SmallPreviewContainer minHeight={height}>
          <SmallPreview
            images={images}
            currentIndex={currentIndex}
            setCurrentIndex={setCurrentIndex}
            onClick={toggleGallery}
          />
          {isOpenGallery && (
            <Preview
              images={images}
              currentIndex={currentIndex}
              totalCount={images.length}
              isOpen={isOpenGallery}
              onClose={toggleGallery}
              setCurrentIndex={setCurrentIndex}
            />
          )}
        </SmallPreviewContainer>
      )}
    </>
  );
};
